import { render, staticRenderFns } from "./CoUserTagsEdit.vue?vue&type=template&id=2be10876&"
import script from "./CoUserTagsEdit.vue?vue&type=script&lang=js&"
export * from "./CoUserTagsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports